export const MMM_OPTIMIZATION_RESULTS_LIST_SEGMENT = 'list';

export const MMM_OPTIMIZATION_RESULTS_BASE_PATH = '/mmm/optimization-results';

// S3 path: {account_id}/Results/{optimization_result_name}/{file_name}
export const MMM_OPTIMIZATION_RESULTS_S3_PATH_PATTERN =
  '{account_id}/Results/{optimization_result_name}/{file_name}';

export const MMM_OPTIMIZATION_RESULTS_FILE_NAMES = {
  MODEL_FIT: 'model_fit.json',
  PAID_OPTIMIZATION: 'paid_optimization.csv',
  ORGANIC_NON_MEDIA: 'organic_non_media.csv',
  BASELINE: 'baseline.csv',
  FIT_METRICS: 'fit_metrics.csv',
  ALL_CHANNELS_EXPORT: 'all_channels_export.csv',
};

export const buildOptimizationResultListPath = () =>
  `${MMM_OPTIMIZATION_RESULTS_BASE_PATH}/${MMM_OPTIMIZATION_RESULTS_LIST_SEGMENT}`;

export const buildOptimizationResultDetailPath = (resultId) =>
  `${MMM_OPTIMIZATION_RESULTS_BASE_PATH}/${encodeURIComponent(resultId)}`;

export const encodeOptimizationResultId = (resultId) =>
  encodeURIComponent(resultId);

export const decodeOptimizationResultId = (encodedId) =>
  decodeURIComponent(encodedId);
